interface Store {
  key: string
  url: string
  image: string
}

/**
 * Sends the user to the app's store listing.
 *
 * Today this is a plain redirect to the store URL. The deep-link phase
 * (open the app if installed, fall back to the store otherwise) will hook in
 * here behind the same signature — callers won't change.
 */
export const openOrInstallApp = (store?: Store): void => {
  if (!store?.url) return

  // TODO(FZSPF-3669): deep-link — try the L1MAX universal link / scheme first,
  // fall back to `store.url` when the app isn't installed.
  window.location.href = store.url
}
